import UserManagement from '@/components/admin/UserManagement'

const AdminUserManagement = () => {
  return <UserManagement roleList="users" />
}

export default AdminUserManagement